import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Section, Title } from "@/components/UI";
export const PartnerBoxWrapper = ({ title, children, partnerBoxRef, display, }) => {
    return (_jsxs(Section, { ref: partnerBoxRef, unsafeClassname: "HideOnPrint", display: display, children: [_jsx(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "spacing.16", children: _jsx(Title, { hasMargin: false, variant: "section", title: title }) }), children] }));
};
